import { render, staticRenderFns } from "./ProjectStatus.vue?vue&type=template&id=20a98f77&scoped=true&"
import script from "./ProjectStatus.vue?vue&type=script&lang=ts&"
export * from "./ProjectStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a98f77",
  null
  
)

export default component.exports